import UserRepository from "@/utilities/repositories/Users";
import { useState } from "react";
import toast from "react-hot-toast";
import { Button, Modal, Password } from "rizzui";

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  userName?: string;
  onSuccess: () => void;
}

export default function ChangePasswordModal({
  isOpen,
  onClose,
  userId,
  userName,
  onSuccess,
}: ChangePasswordModalProps) {
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    if (!password.trim()) {
      toast.error("Please enter a new password");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    try {
      setIsLoading(true);
      await UserRepository.setPassword({
        userId,
        password,
      });
      toast.success("Password updated successfully");
      setPassword("");
      onSuccess();
      onClose();
    } catch (error) {
      toast.error("Failed to update password");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setPassword("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <div className="p-5">
        <h2 className="text-xl font-bold mb-2">Change User Password</h2>
        {userName && (
          <p className="text-gray-600 mb-4">
            User: <span className="font-medium text-gray-900">{userName}</span>
          </p>
        )}
        <Password
          label="New Password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mb-4"
        />
        <div className="flex justify-end gap-3 mt-4">
          <Button variant="outline" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            isLoading={isLoading}
            disabled={isLoading || !password.trim()}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
}
